import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../store"

import { DispatchProps, mapDispatchToProps } from "../../cardview/actions"

import { getItemCardAttachments } from "../selectors"

import InlineAttachment from "./InlineAttachment"
import { Labels } from "../../../util/Translations"
import { IItem } from "../../../models"
import { IAttachment, ILightbox } from "../index"

export interface OwnProps {
    item: IItem
}

interface StateProps {
    lightbox: ILightbox
    attachments: IAttachment[]
}

type Props = OwnProps & StateProps & DispatchProps

interface State {
    shouldShowAllAttachments: boolean
}

export class CardViewInlineAttachment extends React.PureComponent<
    Props,
    State
> {
    private parentAnchorHref: string

    constructor(props: Props) {
        super(props)
        this.parentAnchorHref = ""
        this.state = {
            shouldShowAllAttachments: false,
        }
    }

    render(): JSX.Element {
        const {
            item: { areAttachmentsEditable },
            lightbox,
            attachments,
        } = this.props

        const { shouldShowAllAttachments } = this.state

        const { Attachments } = Labels
        return (
            <InlineAttachment
                wrapperClasses="tw-p-1 tw-w-full md:tw-w-1/2"
                uploadButtonClasses="tw-px-3"
                fieldName={Attachments}
                canAddAttachments={areAttachmentsEditable}
                canEditAttachments={areAttachmentsEditable}
                attachments={attachments}
                showAllDocuments={shouldShowAllAttachments}
                onDeleteAttachment={this.onDeleteAttachment}
                onAddAttachment={this.onAddAttachment}
                loadMoreAttachments={this.loadMoreAttachments}
                onUpdateAttachmentDescription={
                    this.onUpdateAttachmentDescription
                }
                showLightbox={this.showLightbox}
                hideLightbox={this.hideLightbox}
                changeAttachmentInLightbox={this.changeAttachmentInLightbox}
                lightbox={lightbox}
                maxInitialCards={6}
                attachmentsWithoutPagination={attachments}
                onMouseEnterBrowseDrop={this.disableParentAnchor}
                onMouseOutBrowseDrop={this.enableParentAnchor}
            />
        )
    }

    onAddAttachment = (request: UploadRequest): void => {
        const {
            item: { id },
            requestAddAttachment,
        } = this.props

        const formData = new FormData()
        formData.append(request.filename, request.file)
        requestAddAttachment(id, formData)
    }

    onDeleteAttachment = (attachmentId: number): void => {
        const {
            item: { id },
            requestDeleteAttachment,
        } = this.props
        const { DeleteThisAttachment } = Labels
        if (confirm(DeleteThisAttachment)) {
            requestDeleteAttachment(id, attachmentId)
        }
    }

    onUpdateAttachmentDescription = (objectId: number, value: string): void => {
        const {
            item: { id },
            updateAttachmentDescription,
        } = this.props
        updateAttachmentDescription(id, objectId, value)
    }

    loadMoreAttachments = (): void => {
        this.setState({
            shouldShowAllAttachments: true,
        })
    }

    showLightbox = (lightboxStartingIndex: number): void => {
        const {
            item: { id },
            updateLightboxVisibility,
        } = this.props
        updateLightboxVisibility(id, true, lightboxStartingIndex)
    }

    hideLightbox = (): void => {
        const {
            item: { id },
            updateLightboxVisibility,
        } = this.props
        updateLightboxVisibility(id, false)
    }

    changeAttachmentInLightbox = (diff: number): void => {
        const {
            item: { id },
            increaseLightboxCurrentIndex,
        } = this.props
        increaseLightboxCurrentIndex(id, diff)
    }

    disableParentAnchor = (event: React.MouseEvent): void => {
        const target = event.target as HTMLElement
        const parentAnchor = target.closest("a") as HTMLElement
        this.parentAnchorHref = parentAnchor.getAttribute("href") as string
        parentAnchor.removeAttribute("href")
    }

    enableParentAnchor = (event: React.MouseEvent): void => {
        const target = event.target as HTMLElement
        const parentAnchor = target.closest("a") as HTMLElement
        parentAnchor.setAttribute("href", this.parentAnchorHref)
        this.parentAnchorHref = ""
    }
}

const mapStateToProps = (state: GlobalState, props: OwnProps): StateProps => ({
    lightbox: state.cardView.lightboxes[props.item.id],
    attachments: getItemCardAttachments(state.cardView, props),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CardViewInlineAttachment)
